"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _permission = require("@/utils/permission");
var _auth = require("@/utils/auth");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'notify',
  data: function data() {
    return {
      loginType: '0',
      headerNum: [{
        type: '0',
        name: '通知地址配置'
      }],
      merData: {
        api: '',
        type: ''
      },
      submitLoading: false,
      // 提交loading
      loading: false,
      merInfoForm: {
        itemCbUrl: '',
        orderStatusCbUrl: '',
        orderRefundCbUrl: '',
        orderLogisticsCbUrl: ''
      }
    };
  },
  created: function created() {
    this.getInfo();
  },
  methods: {
    handlerTestApi: (0, _validate.Debounce)(function (api, type) {
      var _this = this;
      this.merData.api = api;
      this.merData.type = type;
      this.loading = true;
      (0, _merchant.merchantNotifyAPIByTest)(this.merData).then(function (res) {
        _this.$message.success(res);
        _this.loading = false;
      }).catch(function () {
        _this.$message.error('API 不可用，请稍后再试');
        _this.loading = false;
      });
    }),
    handlerSubmit: (0, _validate.Debounce)(function () {
      var _this2 = this;
      if (this.merInfoForm.itemCbUrl && this.merInfoForm.itemCbUrl !== '') {
        if (!this.validateURL(this.merInfoForm.itemCbUrl)) {
          this.$message.error('商品通知API 格式错误');
          return;
        }
      }
      if (this.merInfoForm.orderStatusCbUrl && this.merInfoForm.orderStatusCbUrl !== '') {
        if (!this.validateURL(this.merInfoForm.orderStatusCbUrl)) {
          this.$message.error('订单状态通知API 格式错误');
          return;
        }
      }
      if (this.merInfoForm.orderRefundCbUrl && this.merInfoForm.orderRefundCbUrl !== '') {
        if (!this.validateURL(this.merInfoForm.orderRefundCbUrl)) {
          this.$message.error('订单退款通知API 格式错误');
          return;
        }
      }
      if (this.merInfoForm.orderLogisticsCbUrl && this.merInfoForm.orderLogisticsCbUrl !== '') {
        if (!this.validateURL(this.merInfoForm.orderLogisticsCbUrl)) {
          this.$message.error('订单物流通知API 格式错误');
          return;
        }
      }
      (0, _merchant.merchantUpdateByNotifyAPI)(this.merInfoForm).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.getInfo();
      });
    }),
    // 验证网址
    validateURL: function validateURL(textval) {
      var urlregex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      return urlregex.test(textval);
    },
    // 获取商户信息
    getInfo: function getInfo() {
      var _this3 = this;
      this.loading = true;
      (0, _merchant.getBaseInfoApi)().then(function (res) {
        _this3.merInfoForm = res.retailerMerchant;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    }
  }
};